import * as React from 'react';
import { createContext, useContext } from 'react';

interface ProviderProps {
    children: React.ReactElement;
    translations: { [key: string]: string };
}

interface ProviderValues {
    translate: (id: string, fallback: string, args?: { [key: string]: string }) => string;
}

interface TranslateProps {
    id: string;
    value: string;
    args?: { [key: string]: string };
}

export const IntlContext = createContext(null);
export const useIntl = (): ProviderValues => useContext(IntlContext);

export function IntlProvider({ children, translations }: ProviderProps) {
    const translate = (id, value, args = {}): string => {
        const label: string = translations[id] ?? value;
        return args
            ? Object.keys(args).reduce((carry: string, arg: string) => {
                  return carry.replace(`{${arg}}`, args[arg]);
              }, label)
            : label;
    };
    return <IntlContext.Provider value={{ translate }}>{children}</IntlContext.Provider>;
}
